
export default {
  data() {
    return {
      doValidate: false,
      doValidateTask: null,
      validationResults: {}
    };
  },
  methods: {
    commit(func = () => { }) {
      this.doValidate = true;
      clearTimeout(this.doValidateTask);
      this.doValidateTask = setTimeout(() => (this.doValidate = false), 5678);
      if (Object.entries(this.validationResults).every(x => x[1])) {
        this.doValidate = false;
        this.doValidateTask = null;
        return func();
      }
    },
    setValidationResult(field, result) {
      if (result === null) {
        delete this.validationResults[field];
        return;
      }
      this.validationResults[field] = result;
    },
  }
};